export enum RegionType {
  city = 'city',
  country = 'country',
}

